import {Component, ViewChild} from '@angular/core';
import {
    App,
    Content,
    NavController,
    NavParams,
    Platform,
    Tab,
    ViewController
} from 'ionic-angular';

import {TGoogleAnalytic, TStatusBar, Util} from "../../../app/util";

import {LogadoService} from '../../../providers/logado-service';
import {CONFIG} from "../../../app/config";
import {TAction, TVoucherFlague} from "../../../app/enum";
import {EntrakiService} from "../../../providers/entraki-service";
import {DataService} from "../../../providers/data-service";
import {ModalActionPage} from "../modal-action/modal-action";
import {BarcodeScanner} from "@ionic-native/barcode-scanner";
import {ProfilePagePage} from "../profile-page/profile-page";
import {SpotdayService} from '../../../providers/spotday-service';

@Component({
    selector: 'page-voucher-info',
    templateUrl: 'voucher-info.html',
    providers: [EntrakiService, SpotdayService]
})
export class VoucherInfoPage {

    @ViewChild(Content) content: Content;

    config: any;

    etapa: number;
    etape: number;
    result: string;

    logado: any;

    spotdayx: any;
    vouchers: any;
    selected: number;
    
    hotspotID: number;
    voucherID: number;
    profileID: number;
    notifyeID: number;

    qrcodeview: boolean;
    qrCodeParsed: string;

    constructor(public util: Util, public navCtrl: NavController, public navParams: NavParams, public viewCtrl: ViewController,
                public app: App,
                public platform: Platform,
                public logadoService: LogadoService,
                public barcodeScanner: BarcodeScanner,
                public entrakiService: EntrakiService,

                public spotdayService: SpotdayService,
                public dataService: DataService) {


        this.config = CONFIG;

        this.etapa = this.navParams.get('etapa');
        this.etape = this.navParams.get('etapa');

        this.logado = this.logadoService.getAuth();

        this.hotspotID = this.navParams.get('hotspotID');
        this.voucherID = this.navParams.get('voucherID');
        this.profileID = this.navParams.get('profileID');
        this.notifyeID = this.navParams.get('notifyeID');
        this.qrcodeview = false;

        this.selected = 0;


        /* Google Analytics */
        this.util.googleAnalytic(TGoogleAnalytic.gaPageview, 'Voucher Info', '/voucher-info');

        if (this.etapa == 0) this.voucherLoad();
        if (this.etapa == 1) this.voucherLoad();
        if (this.etapa == 2) this.spotdayHoje();

    }

    ionViewDidEnter() {

        this.util.statusBarColor(TStatusBar.sbStyleLightContent);

    }

    getTitle() {

        let titulo = (this.spotdayx ? this.util.dataft(this.spotdayx.SpotdayDate) : '');

        if (this.etapa == 0) return 'Voucher';
        if (this.etapa == 1) return 'Voucher';
        if (this.etapa == 2) return titulo;
        if (this.etapa == 3) return titulo;

    }

    spotdayHoje() {

        let loading = this.util.loadingDots();
        loading.present();

        this.spotdayService.spotday(TAction.acHoje, 0, this.hotspotID)
            .finally(() => loading.dismiss())
            .subscribe(
                data => this.spotdayx = data.Spotdays[0],
                erro => this.util.alertResult(erro, () => this.dismiss()));

    }

    voucherLoad(code: string = '') {

        let loading = this.util.loadingDots();
        loading.present();

        this.entrakiService.voucher(TAction.acLoad, 0, this.profileID, '', this.notifyeID, 0, 0, 0, this.voucherID, code)
            .finally(() => loading.dismiss())
            .subscribe(
                data => this.vouchers = data.Vouchers,
                erro => this.util.alertResult(erro, () => this.dismiss()));

    }

    voucherMove() {

        let onOkey = (okey, that, data) => {

            let loading = this.util.loadingDots();
            loading.present();

            let action = (okey.perfilfnd ? TAction.acMove : TAction.acSend);

            this.entrakiService.voucher(action, 0, 0, okey.inputf.text, 0, 0, 0, 0, this.vouchers[this.selected].VoucherID)
                .finally(() => loading.dismiss())
                .subscribe(
                    data => {

                        if (okey.perfilfnd) {
                            this.util.toastSimply('Voucher transferido com sucesso para ' + okey.perfilfnd.ProfileShow + '.');
                            this.logadoService.voucherQtde(-1);
                            that.dismiss();
                            return;
                        }

                        if (!data || !data.Vouchers || data.Vouchers.length != 1) {
                            this.util.toastSimply('Perfil não encontrado');
                            return;
                        }

                        okey.perfilfnd = data.Vouchers[0];
                        okey.corcor = 'CorDash';
                        okey.titulo = okey.perfilfnd.ProfileShow;
                        okey.resumo = 'Transferir para ' + okey.perfilfnd.ProfileShow + '?';
                        okey.imagem = okey.perfilfnd.ProfileFace;
                        okey.action.name = 'Confirmar';
                        this.dismiss(true, 0);

                    },
                    erro => {

                        this.util.alertResult(erro);

                    });
        };

        let objectData = {modalinfo: this.config.modalinfo(this.util, 'vouchermov', onOkey)};
        this.util.modalopen(ModalActionPage, 'full', true, objectData).subscribe();

    }

    profilePage(profileID: number) {

        let activeTab: Tab = this.app.getRootNavs()[0].getActiveChildNavs()[0].getActiveChildNavs()[0];

        if (this.logado.Profile.ProfileID == profileID) {
            activeTab.pop({animate: false}).then(() => this.dismiss());
            return;
        }

        let object = {profileID: profileID};
        activeTab.push(ProfilePagePage, object).then(() => this.dismiss());

    }

    voucherFlug(voucher, flug: 'lock', time?) {

        if (flug == 'lock') {

            if (voucher.VoucherLock == TVoucherFlague.vcVoucherLost) return 'Voucher ' + TVoucherFlague[voucher.VoucherLock].slice(2, 99);
            if (voucher.VoucherData < this.util.dateHoje())          return 'Voucher Expirado';
            if (voucher.VoucherUsed)                                 return 'Voucher Utilizado';
            if (time)                                                return this.util.timeOnly(voucher.Spotday.SpotdayDate);

        }

        return '';
    }

    vouchersee(index) {

        this.selected = index;
        this.etapa = 1;

    }

    qrcodesee() {

        this.qrcodeview = true;
        this.content.resize();


        setTimeout(() => {

            let top = this.util.anyParams(CONFIG.colors.CorWhat, CONFIG.colors[this.vouchers[this.selected].QRTOP]);
            let end = this.util.anyParams(CONFIG.colors.CorBlue, CONFIG.colors[this.vouchers[this.selected].QREND]);
            this.util.qrcolor(this.vouchers[this.selected].VoucherCode, top, end)
                .subscribe(base64 => {
                    this.qrCodeParsed = base64;
                });

        });

    }

    qrcreate() {
/*
        this.barcodeScanner.encode(this.barcodeScanner.Encode.TEXT_TYPE, this.logado.Profile.ProfileID)
            .then(data => {
                console.log(data);
                this.qrcreated = data;
            }).catch(erro => {

            //let text = (!this.platform.is('cordova') ? 'Camera apenas no ambiente "Cordova"' : 'Você precisa fornecer acesso a sua camera para continuar.' + '<br><br>' + erro);
            this.util.alertSimply(erro);

        });
*/
    }

    scanner() {

        if (0==0) {
            //this.vouchers = null;
            //this.voucherLoad('{"Coder":"QrhghaCzpbeiuouGZX13dH53fXd5c2qYrruws7eUkG6Hfn5+f3+AgIF9dJa0x7WVycq3wnmReoiOiIuKio2MjZZ9fo+WmZCWm5KWhOC="}');
            //this.voucherLoad('{"Coder":"MqhQdZCjlaeSqnt2VW1nZWhmZ2lvY1qInqugo6eEgF53bm5ub29wcHFtZIakt6WFubqnsmmBanh+eHt6en18fYZtboB/iYGGi4aLdNC="}');
            //this.checkcode('{"Coder":"MqhQdZCjlaeSqnt2VW1nZWhmZ2lvY1qInqugo6eEgF53bm5ub29wcHFtZIakt6WFubqnsmmBanh+eHt6en18fYZtboB/iYGGi4aLdNC="}');
            //return;
        }


        //Nao é celular nao abre camera
        if (!this.util.nativeApp()) {
            this.util.toastSimply('Use no app para abrir a camera', 4000);
            return;
        }


        let loading = this.util.loadingDots();
        loading.present();

        let option = {showTorchButton: true, formats: 'QR_CODE'};
        this.barcodeScanner.scan(option)
            .then(data => {

                loading.dismiss();

                if (data.cancelled) {
                    this.etapa = this.etape;
                    return;
                }

                this.checkcode(data.text);

            }).catch(erro => {

                loading.dismiss();

                let text = (!this.platform.is('cordova') ? 'Instale o app na Loja' : 'Você precisa fornecer acesso a sua camera para continuar.' + '<br><br>' + erro);
                this.util.alertSimply(text);

        });

    }

    checkcode(barcode) {

        this.etapa = 3;

        let loading = this.util.loadingDots();
        loading.present();

        this.entrakiService.voucher(TAction.acShow, 0, 0, '', this.notifyeID, 0, 0, this.spotdayx.SpotdayID, 0, barcode)
            .finally(() => loading.dismiss())
            .subscribe(
                data => {

                    this.etapa = 2;
                    this.result = 'sei la pq tem isso, sucesso?';
                    this.vouchers = data.Vouchers;

                    setTimeout(() => this.scanner(), 1000);

                },
                erro => {

                    this.etapa = 2;
                    this.result = erro.Result;

                    setTimeout(() => this.scanner(), 1000);

                });

    }

    dismiss(force?, codigo?) {

        //if (this.qrcodeview) {
        //    this.qrcodeview = false;
        //    this.content.resize();
        //    return;
        //}

        if (this.etapa == 1 && this.etape == 0 && !force) {
            this.etapa = 0;
            this.qrcodeview = false;
            this.content.resize();
            return;
        }

        let result = null;
        if (codigo >= 0) result = {Codigo: codigo};

        this.viewCtrl.dismiss(result);
        this.util.statusBarColor(TStatusBar.sbStyleDefault);

    }

}



// WEBPACK FOOTER //
// ./src/pages/sync/voucher-info/voucher-info.ts